import { defineComponent as _defineComponent } from 'vue'
import { reactive } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import DatePicker from "@/components/ui/DatePicker.vue";
  import useVuelidate from "@vuelidate/core";
  import { required, requiredIf } from "@vuelidate/validators";
  import dayjs from "dayjs";
  import { useStore } from "vuex";
  import { getChangedFields } from "@/helpers/getChangedFields";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SetRegistrationDateModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    listForUpdate: {
      type: Array,
      required: true,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;
  const props = __props;
  const minDate = dayjs().format("YYYY-MM-DD");
  const maxDate = dayjs().add(2, "year").format("YYYY-MM-DD");

  const form = reactive({
    registrationDate: "",
  });
  const rules = {
    registrationDate: { required },
  };
  const v$ = useVuelidate(rules, form);

  function close(update = false) {
    form.registrationDate = "";
    resetVuelidateErrors(v$);
    emits("close", update);
  }
  const save = () => {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    const normalizedData = {
      registrationDate: dayjs(form.registrationDate).isValid()
        ? dayjs(form.registrationDate).toISOString()
        : form.registrationDate,
      lotIds: props.listForUpdate
        .filter((listItem) => listItem.selected)
        .map((item) => item.id),
    };

    store.dispatch("lot/setRegistrationDate", normalizedData).then(() => {
      emits("update");
      close(true);
    });
  };

const __returned__ = { store, emits, props, minDate, maxDate, form, rules, v$, close, save, reactive, Modal, DatePicker, get useVuelidate() { return useVuelidate }, get required() { return required }, get requiredIf() { return requiredIf }, get dayjs() { return dayjs }, get useStore() { return useStore }, get getChangedFields() { return getChangedFields }, get resetVuelidateErrors() { return resetVuelidateErrors } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})